{
  "pages": {
    "locations": {
      "title": "List of locations",
      "uploadLocationList": "Upload location list",
      "locationListTemplate": "Template",
      "downloadTooltip": "If you want to modify your list of locations you can download, modify and upload your list or ask our team member for help.",
      "actions": {
        "excludeFromAudit": "Ask to exclude from audit",
        "changeSpendAreas": "Ask to change spend areas",
        "includeIntoAudit": "Ask to include into audit",
        "displayNotApplicable": "Display not applicable locations"
      }
    }
  },
  "components": {
    "locationTable": {
      "columns": {
        "number": "Number/name",
        "streetAddress": "Street address",
        "city": "City",
        "state": "State",
        "zip": "ZIP",
        "taxId": "Tax ID",
        "status": "Location status",
        "spendAreas": "Spend areas",
        "stages": "Stages",
        "savings": "Savings",
        "contractedCost": "Costs",
        "LocationId": "Location ID",
        "autoPayEnabled": "Auto Pay Enabled",
        "spend": "Spend",
        "documentFieldStatus": "Document field status",
        "more": "More",
        "stagesBadge": "{{count}} stages",
        "missingField": "*missing field"
      }
    },
    "locationListActions": {
      "askToExclude": "Ask to exclude from audit",
      "askToChangeSpendAreas": "Ask to change assigned spend areas"
    },
    "auditDialog": {
      "selectedLocations": "Selected locations:",
      "exclude_from_audit": {
        "title": "Are you sure you want to exclude {{count}} locations from your audit?",
        "description": "You've asked us to exclude selected locations from the audit. This may take a few business days. You can always ask us to include them again.",
        "descriptionNotApplicable": "You've asked us to exclude selected locations from the audit. This may take a few business days. You'll find your locations in the 'not applicable' section. You can always ask us to include them again.",
        "confirmLabel": "Exclude locations"
      },
      "include_in_audit": {
        "title": "Are you sure you want to include {{count}} locations into your audit?",
        "description": "You've asked us to include selected locations into the audit. You can always ask us to exclude them again.",
        "confirmLabel": "Include locations"
      },
      "change_spend_area": {
        "title": "Are you sure you want to change spend areas for {{count}} locations?",
        "description": "You've asked us to update spend areas for selected locations.",
        "confirmLabel": "Change Spend Areas"
      }
    },
    "noData": {
      "noLocations": {
        "title": "No list of locations has been uploaded yet",
        "description": "Please download our template (top right corner), fill it in with your data, and upload it. You can add it by using the button below.",
        "recommendation": "You will see the results immediately – if any required fields are missing, they will be highlighted",
        "action": "Upload template",
        "placeholder": "List of locations will appear here once uploaded"
      },
      "noVectorLocations": {
        "title": "No locations available",
        "description": "There are no vector locations associated with this location. Please check back later or contact support for more information."
      }
    }
  },
  "notifications": {
    "locationListUpload": {
      "success": {
        "message": "File successfully uploaded",
        "description": "Upload location list completed successfully, your file will now be verified."
      },
      "error": {
        "message": "Failed uploading location list",
        "description": "Please try again later"
      }
    },
    "locationListAction": {
      "locationBeingProcessed": "Action unavailable. This location is currently being processed by the CRM",
      "success": {
        "message": "Action successful",
        "description": "Action performed successfully"
      },
      "error": {
        "message": "Action failed",
        "description": "Please try again later"
      }
    }
  }
}
